import * as angular from "angular";
import MODULE_NAME from "../app.module.ajs";

interface IModuleMigrationStatus {
    AJSComponentCount: number;
    MigratedComponentCount: number;
    ServiceCount: number;
    OtherCount: number;
}

export class ConstantsService {

    static $inject = ["apiUrl", "googleMapsApiKey", "reportsApiUrl", "isMobile", "isLocalDevelopment", "isDev", "isUat", "isDemoSite", "isProduction", "isFleet", "tokenUrl"];

    constructor(
        private readonly apiUrl: string,
        private readonly googleMapsApiKey: string,
        private readonly reportsApiUrl: string,
        private readonly isMobile: boolean,
        private readonly isLocalDevelopment: boolean,
        private readonly isDev: boolean,
        private readonly isUat: boolean,
        private readonly isDemoSite: boolean,
        private readonly isProduction: boolean,
        private readonly isFleet: boolean,
        private readonly tokenUrl: string
    ) {
        if (this.isLocalDevelopment) {
            var migrationStatus = this.calculateAngularJSComponents(MODULE_NAME);

            //console.log("Angular Migration Status", this.moduleCount, migrationStatus);
            var totalComponentCount = migrationStatus.AJSComponentCount + migrationStatus.MigratedComponentCount;
            var migrationPercentage = Math.round(migrationStatus.MigratedComponentCount * 100 / totalComponentCount);
            //console.log("%cAngular Migration", "font-weight: bold;");

            //console.log(" - AJS Components", migrationStatus.AJSComponentCount);
            //console.log(" - Migrated Components", migrationStatus.MigratedComponentCount, ``);
            //console.log(" - Services", migrationStatus.ServiceCount);
            //console.log(" - Other", migrationStatus.OtherCount);

            // Print bar
            var scaleFactor = 2;
            var greenBar = Array(scaleFactor * Math.round(Math.round(migrationPercentage / 10))).join('█');
            var greyBar = Array(scaleFactor * Math.round(Math.round(10 - (migrationPercentage / 10)))).join('█');
            /*console.log(` - Progress %c${greenBar}%c${greyBar} %c(${migrationPercentage})%`, 'color: green', 'color: lightgrey', 'color: green')*/

            console.log("| Migration -----------------");
            console.log(`| %c${greenBar}%c${greyBar} %c${migrationPercentage}%`, 'color: green', 'color: lightgrey', 'color: green');
            console.log(`| Files: %c${migrationStatus.MigratedComponentCount} / ${totalComponentCount}`, 'color: grey');
            console.log("| ---------------------------");

            // 31.08.2022. 135 / 423 (32%)
            // 29.12.2022. 175 / 470 (37%)
            // 31.07.2024. 278 / 503 (55%)
        }
    }

    getApiUrl() {
        return this.apiUrl;
    }

    getGoogleMapsApiKey() {
        return this.googleMapsApiKey;
    }

    getReportsApiUrl() {
        return this.reportsApiUrl;
    }

    getIsMobile() {
        return this.isMobile;
    }

    getIsLocalDevelopment() {
        return this.isLocalDevelopment;
    }

    getIsDev() {
        return this.isDev;
    }

    getIsUat() {
        return this.isUat;
    }

    getIsDemoSite() {
        return this.isDemoSite;
    }

    getIsProduction() {
        return this.isProduction;
    }

    getIsFleet() {
        return this.isFleet;
    }

    getTokenUrl() {
        return this.tokenUrl;
    }

    // Migration status

    moduleDirectory: IModuleMigrationStatus[] = [];
    moduleCount = 0;

    calculateAngularJSComponents(moduleName: string): IModuleMigrationStatus {
        if (this.moduleDirectory[moduleName]) {
            return null;
        }

        // Do lookup to see if name exists in Angular??

        var migrationStatus: IModuleMigrationStatus = {
            AJSComponentCount: 0,
            MigratedComponentCount: 0,
            OtherCount: 0,
            ServiceCount: 0
        };

        this.moduleDirectory[moduleName] = migrationStatus;
        this.moduleCount++;

        var module = angular.module(moduleName);

        // Calculate counts
        module['_invokeQueue'].forEach((iq) => {
            switch (iq[1]) {
                case "component":
                    migrationStatus.AJSComponentCount++;
                    break;

                case "service":
                    migrationStatus.ServiceCount++;
                    break;

                case "directive":
                    migrationStatus.MigratedComponentCount++;
                    break;

                default:
                    migrationStatus.OtherCount++;
                    break;
            }
        });

        // Sub modules
        module.requires.forEach(subModule => {
            if (subModule.indexOf("app.") >= 0) {
                var subModuleStatus = this.calculateAngularJSComponents(subModule);

                if (subModuleStatus) {
                    migrationStatus.AJSComponentCount += subModuleStatus.AJSComponentCount;
                    migrationStatus.MigratedComponentCount += subModuleStatus.MigratedComponentCount;
                    migrationStatus.ServiceCount += subModuleStatus.ServiceCount;
                    migrationStatus.OtherCount += subModuleStatus.OtherCount;
                }
            }
        });

        //console.log("Calculating for ", moduleName, /*module,*/ migrationStatus);
        return migrationStatus;
    }
}
